import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Suppress Fabric.js image loading errors (CORS issues)
// This must be set before React renders to prevent the error overlay
window.addEventListener('error', (e) => {
  if (e.message && (e.message.includes('fabric:') || e.message.includes('Error loading'))) {
    e.preventDefault();
    e.stopImmediatePropagation();
    console.warn('Suppressed Fabric error:', e.message);
    return false;
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason?.message || String(e.reason) || '';
  if (msg.includes('fabric') || msg.includes('Error loading')) {
    e.preventDefault();
    e.stopImmediatePropagation();
    console.warn('Suppressed Fabric rejection:', msg);
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
